const binding = { modules: {}, dataActions: {} };

    (binding.modules['custom-navigation-menu'] = {
        c: () => require('partner/modules/custom-navigation-menu/custom-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-navigation-menu'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|custom-navigation-menu|custom-navigation-menu'] = {
                c: () => require('partner/modules/custom-navigation-menu/custom-navigation-menu.view.tsx'),
                cn: '__local__-__local__-custom-navigation-menu'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };